import { useQuery } from "react-query";
import { API_KEY_GET_ADMIN_TOP_STATS, getTopStats } from "../api";

export const useGetTopStats = () => {
  return useQuery(API_KEY_GET_ADMIN_TOP_STATS, () => getTopStats());
};
